import React from 'react';
import { AddressListEntry } from '../pages/Konto/SubPages/AdressList';
import './AdressPicker.scss';

export interface AdressPickerEntry extends AddressListEntry {
  sammlung_shipmentdays?: string;
}

export interface AdressPickerProps {
  list: AdressPickerEntry[];
  selectedId?: number;
  onSelect?: (adress_id: string) => void;
  isLieferTermin?: boolean;
  showNewCard?: boolean;
  showBadges?: boolean;
}

export default class AdressPicker extends React.Component<AdressPickerProps> {
  private navigateToEdit(adress_id: number) {
    let winAny: any = window;
    if (winAny.historyHelper?.browser != undefined) {
      winAny.historyHelper.browser.push('/konto/address/' + adress_id);
    }
  }

  render(): React.ReactNode {
    const dayNames = ['Mo', 'Di', 'Mi', 'Do', 'Fr'];
    const { list, selectedId, onSelect, isLieferTermin, showNewCard, showBadges } = this.props;

    return (
      <div className="adressPickerList">
        {list.map((item) => {
          const isSelected = item.adress_id == selectedId;
          let liefertage: string[] = [];
          if (isLieferTermin && item.sammlung_shipmentdays) {
            liefertage = item.sammlung_shipmentdays
              .split(',')
              .filter((d) => d.trim() !== '')
              .map((d) => dayNames[parseInt(d)] ?? d);
          }
          return (
            <div
              key={'adresspicker_' + item.adress_id}
              className={'adressPickerCard' + (isSelected ? ' selected' : '')}
              onClick={() =>
                onSelect
                  ? onSelect(String(item.adress_id))
                  : this.navigateToEdit(item.adress_id)
              }
              style={{ position: 'relative' }}
            >
              <button
                className="adressPickerEditBtn"
                onClick={(e) => {
                  e.stopPropagation();
                  this.navigateToEdit(item.adress_id);
                }}
                title="Adresse bearbeiten"
              >
                ✏
              </button>
              <div className="adressPickerName">
                {item.firstname} {item.lastname}
              </div>
              {item.company ? (
                <div className="adressPickerCompany">{item.company}</div>
              ) : null}
              <div>
                {item.stret} {item.house_number}
              </div>
              <div>
                {item.postcode} {item.city}
              </div>
              {liefertage.length > 0 && (
                <div className="adressPickerLiefertage">
                  Liefertage: {liefertage.join(', ')}
                </div>
              )}
              {showBadges && (
                <div className="adressPickerBadges">
                  {item.isBillingDefault && (
                    <span className="adressPickerBadge adressPickerBadge--billing">
                      Rechnung*
                    </span>
                  )}
                  {item.isShippingDefault && (
                    <span className="adressPickerBadge adressPickerBadge--shipping">
                      Versand*
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
        {showNewCard && (
          <div
            className={
              'adressPickerCard adressPickerNew' +
              (selectedId == undefined ? ' selected' : '')
            }
            onClick={() => onSelect && onSelect('new')}
          >
            + Neue Adresse
          </div>
        )}
      </div>
    );
  }
}
